import { useState } from 'react'
import './Auth.scss'
import image from '../../assets/images/4.jpeg'
import FormLoader from '../../components/loader/FormLoader'
import { useNavigate } from 'react-router-dom'
import { useGlobalContext } from '../../utils/Context'
import { postNo } from '../../utils/Api'

function UserLogin() {
  const { notify } = useGlobalContext()
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  function handleSubmit(data: any) {
    setLoading(true)
    postNo('business_admin/login', data)
      .then((res) => {
        if (res.status === 200) {
          console.log(res.data)
          sessionStorage.setItem('user', JSON.stringify(res?.data?.admin))
          sessionStorage.setItem('token', res?.data?.access_token)
          sessionStorage.setItem('refreshToken', res?.data?.refresh_tokens)
          setLoading(false)
          notify('success', res.message)
          navigate('/developer/home')
        } else {
          notify('error', res.message)
          setLoading(false)
        }
      })
      .catch(() => {
        setLoading(false)
      })
  }
  return (
    <div className='auth flex'>
      <div className='left'>
        <img src={image} alt='delivery man image' />
      </div>
      <div className='right flex items-center'>
        <div className='wrap'>
          <div className='top'>
            <h1>Welcome back</h1>
            <p>Please login with your QC Express Sandbox account</p>
          </div>
          <form
            onSubmit={(e: any) => {
              e.preventDefault()
              const account = e.target.account.value
              const password = e.target.password.value
              if (!account || !password) {
                notify('warn', 'Please fill in all fields')
                return
              }
              // Handle form submission
              handleSubmit({ email: account.toLowerCase(), password })
            }}
          >
            <div className='card'>
              <p>Email</p>
              <input type='email' name='account' />
            </div>
            <div className='card'>
              <p>Password</p>
              <input type='password' name='password' />
            </div>
            <div className='card btn'>
              {loading ? (
                <FormLoader position='center' />
              ) : (
                <button type='submit'>Sign In</button>
              )}
            </div>
            {/* <div className='card forgot flex'>
                <Link to='/aggregators/login'>
                  <p>Aggregator?</p>
                </Link>
                <Link to='/forgot-password'>
                  <p>Forgot Password?</p>
                </Link>
              </div> */}
          </form>
          {/* <div className='new'>
            <h5>New to QC Express Developer Portal?</h5>
            <button onClick={() => navigate('/create-account')}>
              Make an Onboarding Request
            </button>
          </div> */}
        </div>
      </div>
    </div>
  )
}

export default UserLogin
